import { BsFileText, BsHeadset, BsHourglass } from "react-icons/bs";
import { GoLaw } from "react-icons/go";
import { LuFilePen } from "react-icons/lu";
import { LiaUserEditSolid } from "react-icons/lia";
import { RiCustomerService2Line } from "react-icons/ri";


const ServiceItems = ({pageContent}) => {

    const { title, subtitle1, subtitle2, cat1, cat1_desc, cat2, cat2_desc, cat3, cat3_desc, about_img_url, about_name, about_title, about_text, more_sandy, created_at, del } = pageContent;

  return (
    <>
    {/* <div className="group gap-2"> */}
        <a href="/services/interpretation"><div className="group relative place-items-center services-container">
            <RiCustomerService2Line size={54} className="services-icon" />
            <p className="mt-4 text-base font-semibold text-gray-900">
                {/* {cat2_desc} */}
                Interpretation
            </p>
            <h3 className="text-sm text-gray-500">
                <a href="">
                    {/* <span className="absolute inset-0" />
                    {cat2} */}
                    Remote/In-person interpretation (courts, conferences, hospitals)
                </a>
            </h3>
        </div></a>

        <a href="/services/translation"><div className="group relative place-items-center services-container">
            <LuFilePen size={48} className="services-icon" />
            <p className="mt-4 text-base font-semibold text-gray-900">
                {/* {cat2_desc} */}
                Translation
            </p>
            <h3 className="text-sm text-gray-500">
                <a href="">
                    {/* <span className="absolute inset-0" />
                    {cat2} */}
                    Document translation <br></br> (business, legal, medical, etc.)
                </a>
            </h3>
        </div></a>

        <a href="#"><div className="group relative place-items-center services-container">
            <LiaUserEditSolid size={54} className="services-icon" />
            <p className="mt-4 text-base font-semibold text-gray-900">
                Custom Service
            </p>
            <h3 className="text-sm text-gray-500">
                <a href="">
                    Let us know of what you want to achieve and we will make it happen
                </a>
            </h3>
        </div></a>
    {/* </div> */}

        {/* <div className="group relative place-items-center services-container">
            <GoLaw size={54} className="services-icon" />
            <p className="mt-4 text-base font-semibold text-gray-900">
                Legal Assistance
            </p>
            <h3 className="text-sm text-gray-500">
                <a href="">
                    Help with immigration documents, contracts, and agreements
                </a>
            </h3>
        </div> */}
    </>
  )
}

export default ServiceItems
